module.exports = __webpack_public_path__ + "img/m_gurkopashova.d6a3e1a3.jpg";